import { IconChevronDown, IconChevronRight, IconExternalLink, IconUser } from "@tabler/icons-react";
import { Stack } from "@altimateai/lego";
import { FC, useState } from "react";
import { useIntercom } from "react-use-intercom";
import { Link } from "react-router-dom";

export const HelpSection: FC = () => {
  const [isHelpExpanded, setIsHelpExpanded] = useState(false);
  const { show } = useIntercom();
  return (
    <div>
      <button
        onClick={() => setIsHelpExpanded(!isHelpExpanded)}
        className="al-flex al-items-center al-gap-1 al-text-sm al-text-gray-600 hover:al-text-blue-600 al-transition-colors"
      >
        {isHelpExpanded ? (
          <IconChevronDown className="al-w-4 al-h-4" />
        ) : (
          <IconChevronRight className="al-w-4 al-h-4" />
        )}
        <span className="al-font-semibold">Need help?</span>
      </button>

      {isHelpExpanded && (
        <Stack gap={"md"} className={"al-w-full al-mt-3"}>
          <Link
            to="https://docs.altimate.ai/update/docs/closing-the-loop#/"
            role={"button"}
            className={"al-flex al-items-start al-gap-2 al-p-2 al-w-full al-border al-rounded-md"}
          >
            <IconExternalLink className="al-size-6" />
            <Stack direction={"column"} gap={"none"}>
              <span className="al-whitespace-nowrap al-text-brand">Documentation</span>
              <span className={"al-text-xs al-text-muted-foreground"}>
                Learn more about Closing the Loop on Opportunities
              </span>
            </Stack>
          </Link>
          <Stack
            role={"button"}
            onClick={show}
            gap={"md"}
            align={"start"}
            className={"al-p-2 al-w-full al-border al-rounded-md"}
          >
            <IconUser className="al-size-4 al-mt-1" />
            <Stack direction={"column"} gap={"none"}>
              <span className="al-whitespace-nowrap al-text-brand">Support</span>
              <span className={"al-text-xs al-text-muted-foreground"}>Get help from our team</span>
            </Stack>
          </Stack>
        </Stack>
      )}
    </div>
  );
};
